import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { RentButton } from "@/components/units/actions/RentButton";
import { ReserveButton } from "@/components/units/actions/ReserveButton";
import { QuoteButton } from "@/components/units/actions/QuoteButton";
import { useRentalAction } from "@/hooks/useRentalAction";
import { useReservationAction } from "@/hooks/useReservationAction";
import { useTriggerButtonVisibility } from "@/hooks/useTriggerButtonVisibility";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";

export const UnitCheckout = () => {
    const { unitGroup, selectedPromo } = useUnitItemContext();

    const { openRentalFunnel, label: rentLabel } = useRentalAction(
        unitGroup,
        selectedPromo,
    );

    const { openReservationFunnel, label: reserveLabel } = useReservationAction(
        unitGroup,
        selectedPromo,
    );

    const { canRent, canReserve, canSoftReserve } =
        useTriggerButtonVisibility(unitGroup);

    return (
        <div className="unit-checkout tw:flex-1 tw:overflow-y-auto tw:py-4">
            {canRent && (
                <Card>
                    <CardHeader>
                        <CardTitle>Rent Your Unit</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <ul className="tw:list-disc">
                            <li>Move in as soon as today.</li>
                            <li>Simple online rental process.</li>
                        </ul>
                        <RentButton
                            handleRentalClick={openRentalFunnel}
                            label={rentLabel}
                        />
                    </CardContent>
                </Card>
            )}
            {canReserve && (
                <Card>
                    <CardHeader>
                        <CardTitle>Reserve Your Unit</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <ul className="tw:list-disc">
                            <li>Move in when you're ready.</li>
                            <li>No obligation to rent.</li>
                        </ul>
                        <ReserveButton
                            label={reserveLabel}
                            onReservationClick={openReservationFunnel}
                        />
                    </CardContent>
                </Card>
            )}
            {canSoftReserve && (
                <Card>
                    <CardHeader>
                        <CardTitle>Get a Quote</CardTitle>
                        <CardDescription>Secure your rate.</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <div>
                            Quote and special can expire after 7 days. Can be
                            converted to a rental or reservation.
                        </div>
                        <QuoteButton
                            unitGroup={unitGroup}
                            selectedPromo={selectedPromo}
                            navigateToPage
                        />
                    </CardContent>
                </Card>
            )}
        </div>
    );
};
